import React, { Component } from 'react';
import {numberParce} from '../../../../server/util';
class TotalTransactions extends Component {
    render() {
        const {data}=this.props
        return (
            <div className="mini-stat bg-4 clearfix rounded text-center">
            <span className="mini-stat-icon" style={{float:'none'}}><i className="fa fa-exchange fg-4"></i></span>
            <div className="mini-stat-info">
                Total Transactions Amount
                {data.loading?<span className='loading'></span>:<span>$ {numberParce(((data.data||{}).TotalTrx||{}).totalAmount).toFixed(2)}</span>}                
            </div>
        </div>
        );
    }
}
export default TotalTransactions;


// WEBPACK FOOTER //
// ./src/components/SuperAdmin/Home/DashboardItems/totalTransactions.jsx